import { CheckoutContactsData } from 'modules/checkout/contacts/duck/model';
import { Selector } from 'model/State';

export default <T>(
    selector: (checkoutContactsData: CheckoutContactsData) => T,
  ): Selector<T | null | undefined> =>
  (s) =>
    s.checkout.contacts.data.map(selector).result;
